// client/src/reservations/utils/money.js
export function formatMoney(amount, currency='EUR') {
  try {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(Number(amount || 0));
  } catch {
    return `${amount?.toFixed?.(2) ?? amount} ${currency}`;
  }
}
